import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  color: #00ff00;
  font-size: 2.2rem;
  margin: 0;
`;

const Button = styled.button`
  background-color: #000;
  color: #00ff00;
  border: 1px solid #00ff00;
  padding: 10px 18px;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #00ff00;
    color: #000;
  }
`;

const FilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border: 1px solid #00ff00;
  padding: 15px;
  overflow-y: auto;
`;

const FileItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid rgba(0, 255, 0, 0.3);
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(0, 255, 0, 0.1);
  }

  &:last-child {
    border-bottom: none;
  }
`;

const FileIcon = styled.div`
  width: 24px;
  height: 24px;
  border: 1px solid #00ff00;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
`;

const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const FileName = styled.div`
  font-size: 1.5rem;
`;

const FileDetails = styled.div`
  font-size: 1.1rem;
  color: rgba(0, 255, 0, 0.7);
`;

const Instructions = styled.div`
  color: #00ff00;
  text-align: center;
  margin-top: 20px;
  font-size: 1.5rem;
`;

// Generate mock file data with Severance-style department/room names
const generateMockFiles = () => {
  // Departments and rooms from Severance
  const departments = [
    'O&D', // Optics & Design
    'MDR', // Macrodata Refinement
    'WEL', // Wellness
    'CRD', // The Perpetuity Wing (Records)
    'BRN', // The Board Room
    'SVR', // The Severed Floor
    'SCR', // Security
    'BRK', // Break Room
    'CTL', // Control Room
    'TST', // Testing Floor
  ];
  
  // File categories
  const categories = [
    'CONTINGENCY', 
    'PROTOCOL',
    'COMPLIANCE',
    'DIRECTIVE',
    'EMERGENCY',
    'STANDARD'
  ];
  
  // File status
  const statuses = [
    'ACTIVE',
    'PENDING',
    'RESTRICTED',
    'CLASSIFIED',
    'AUTHORIZED'
  ];
  
  const files = [];
  
  for (let i = 0; i < 15; i++) {
    const dept = departments[Math.floor(Math.random() * departments.length)];
    const category = categories[Math.floor(Math.random() * categories.length)];
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const fileNum = Math.floor(Math.random() * 900) + 100; // 100-999
    const size = Math.floor(Math.random() * 900) + 100; // 100-999
    const year = 1970 + Math.floor(Math.random() * 53); // 1970-2023
    
    files.push({
      id: i,
      name: `${dept}-${category}-${fileNum}`,
      type: dept,
      category,
      status,
      size,
      date: `${year}-${Math.floor(Math.random() * 12) + 1}-${Math.floor(Math.random() * 28) + 1}`
    });
  }
  
  return files.sort((a, b) => a.name.localeCompare(b.name));
};

const FileSelection = ({ onFileSelect, onLogout }) => {
  const [files] = useState(generateMockFiles());
  const [selectedFileId, setSelectedFileId] = useState(null);

  const handleFileClick = (file) => {
    setSelectedFileId(file.id);
    setTimeout(() => {
      onFileSelect(file);
    }, 500);
  };

  return (
    <Container>
      <Header>
        <Title>LUMON INDUSTRIES - DATA FILES</Title>
        <Button onClick={onLogout}>LOGOUT</Button>
      </Header>

      <FilesContainer>
        {files.map(file => (
          <FileItem 
            key={file.id} 
            onClick={() => handleFileClick(file)}
            style={{ backgroundColor: selectedFileId === file.id ? 'rgba(0, 255, 0, 0.1)' : 'transparent' }}
          >
            <FileIcon>MDR</FileIcon>
            <FileInfo>
              <FileName>{file.name}</FileName>
              <FileDetails>Status: {file.status} | Size: {file.size}kb | Date: {file.date}</FileDetails>
            </FileInfo>
          </FileItem>
        ))}
      </FilesContainer>

      <Instructions>
        Select a file to begin refinement procedure
      </Instructions>
    </Container>
  );
};

export default FileSelection;
